/**
 * 点検整備履歴一覧 型定義
 */
export type TTenkenSeibiTable = {
  点検整備一覧: TTenkenSeibi[]
}

export type TTenkenSeibi = {
  車輌点検整備ID?: number
  車輌ID?: number
  点検整備予定日: string
  点検整備実施日: string
  オイルエレメント交換フラグ: number
  タイヤ交換フラグ: number
  その他整備フラグ: number
  メーター数値: string
  タイヤサイズ: string
  点検整備費: number
  消費税: number
  重量税: number
  自動車税: number
  備考: string
  車種区分ID: number
  車種区分コード: string
  車種区分名称1: string
  車種区分ソート番号: number
  登録番号: string
  登録年月日: string
  廃車年月: string
  廃車予定年月: string
  初年度登録年月: string
  原動機有無フラグ: number
  点検整備区分ID: number
  点検整備区分コード: string
  点検整備区分名称1: string
  点検整備区分名称2: string
  点検整備区分ソート番号: number
  タイヤ種類区分ID: number
  タイヤ種類区分コード: string
  タイヤ種類区分名称1: string
  タイヤ種類区分ソート番号: number
  タイヤメーカー区分ID: number
  タイヤメーカー区分コード: string
  タイヤメーカー区分名称1: string
  タイヤメーカー区分ソート番号: number
  支払先ID: number
  支払先コード: string
  支払先名: string
  支払先略称: string
  削除フラグ: number
  更新日時?: string
}

/**
 * 点検整備履歴一覧 初期値
 */
export const initialTenkenSeibiTableState: TTenkenSeibiTable = {
  点検整備一覧: [],
}
